import React from 'react';
import AgentFormWithTabs from '../components/AgentFormWithTabs';

const AgentCreatePage = () => {
  return <AgentFormWithTabs mode="create" />;
};

export default AgentCreatePage;
